module.exports = __webpack_public_path__ + "images/fcd3c6d4c2fc725d38b8a6d1ffd53122.svg";